import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';

const SideLeaderboard = ({ selectedCategory }) => {
  const [topBeans, setTopBeans] = useState([]);
  const db = getDatabase();

  useEffect(() => {
    const beansRef = ref(db, 'beans');
    const unsubscribe = onValue(beansRef, (snapshot) => {
      const data = snapshot.val();
      let allBeans = [];
      if (data) {
        for (let id in data) {
          allBeans.push({ id, ...data[id] });
        }
      }

      const filteredBeans = selectedCategory
        ? allBeans.filter(bean => bean.category === selectedCategory)
        : allBeans;

      // Sort beans by likes in descending order and take the top 10
      const sortedBeans = filteredBeans.sort((a, b) => b.likes - a.likes).slice(0, 10);
      setTopBeans(sortedBeans);
    });

    return () => unsubscribe();
  }, [db, selectedCategory]);

  return (
    <div className="side-leaderboard-container">
      <h2>Top 10 Beanz</h2>
      <button 
        onClick={() => window.open('https://buymeacoffee.com/onlybeanz', '_blank')}
        style={{
          background: 'linear-gradient(135deg, #ff6b6b 0%, #feca57 100%)',
          color: 'white',
          padding: '12px 16px',
          fontSize: '14px',
          border: 'none',
          borderRadius: '20px',
          cursor: 'pointer',
          margin: '0 0 15px 0',
          fontWeight: 'bold',
          width: '100%',
          boxShadow: '0 2px 10px rgba(255, 107, 107, 0.3)',
          transition: 'transform 0.2s ease'
        }}
        onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
      >
        ☕ Support OnlyBeanz
      </button>
      <div className="side-bean-list">
        {topBeans.map((bean, index) => (
          <div key={bean.id} className="side-bean-item">
            <span className="leaderboard-rank">{index + 1}</span>
            <img src={bean.image} alt={bean.title} />
            <div className="side-bean-info">
              <h3>{bean.title}</h3>
              <p>Likes: {bean.likes}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SideLeaderboard;